const prodToken = 'pk.eyJ1Ijoib2VhbXRjZ2VvMSIsImEiOiJja20zNHd1aHUwOGUxMnlwNjJ4ampzNThsIn0.znGDhNTT8XaijsBjkscJqw'
const testToken = 'pk.eyJ1Ijoib2VhbXRjZ2VvMSIsImEiOiJja20zNHlrcTMwOGV1MndxZGhyMnQ5MWlhIn0.cDRQEFuMTA0y-fi8eGpGHg'
const isProd = document.location.host.startsWith('www')

const MapboxConfig = {
  accessToken: isProd ? prodToken : testToken
}

export default MapboxConfig
